"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddFolder = function AddFolder(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M18.75 7.8125H6.25C5.96235 7.8125 5.72917 8.04569 5.72917 8.33333V16.6667C5.72917 16.9543 5.96235 17.1875 6.25 17.1875H18.75C19.0376 17.1875 19.2708 16.9543 19.2708 16.6667V8.33333C19.2708 8.04569 19.0376 7.8125 18.75 7.8125Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M6.25 7.81258H10.9375V6.25008C10.9375 6.11195 10.8826 5.97947 10.785 5.8818C10.6873 5.78412 10.5548 5.72925 10.4167 5.72925H6.25C6.11187 5.72925 5.97939 5.78412 5.88172 5.8818C5.78404 5.97947 5.72917 6.11195 5.72917 6.25008V8.33342C5.72917 8.19528 5.78404 8.0628 5.88172 7.96513C5.97939 7.86745 6.11187 7.81258 6.25 7.81258Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14.5833 11.9793H13.0208V10.4168C13.0208 10.2787 12.966 10.1462 12.8683 10.0485C12.7706 9.95087 12.6381 9.896 12.5 9.896C12.3619 9.896 12.2294 9.95087 12.1317 10.0485C12.034 10.1462 11.9792 10.2787 11.9792 10.4168V11.9793H10.4167C10.2785 11.9793 10.1461 12.0342 10.0484 12.1319C9.95071 12.2296 9.89584 12.362 9.89584 12.5002C9.89584 12.6383 9.95071 12.7708 10.0484 12.8684C10.1461 12.9661 10.2785 13.021 10.4167 13.021H11.9792V14.5835C11.9792 14.7216 12.034 14.8541 12.1317 14.9518C12.2294 15.0495 12.3619 15.1043 12.5 15.1043C12.6381 15.1043 12.7706 15.0495 12.8683 14.9518C12.966 14.8541 13.0208 14.7216 13.0208 14.5835V13.021H14.5833C14.7215 13.021 14.8539 12.9661 14.9516 12.8684C15.0493 12.7708 15.1042 12.6383 15.1042 12.5002C15.1042 12.362 15.0493 12.2296 14.9516 12.1319C14.8539 12.0342 14.7215 11.9793 14.5833 11.9793Z",
    fill: props.foregroundColor
  }));
};

AddFolder.defaultProps = {
  altText: "Add Folder",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
AddFolder.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = AddFolder;
exports.default = _default;